import { Box, BoxProps } from "@/components/layout/flexbox";
import { LIGHTEST_BACKGROUND } from "@/css/constants";

interface CardProps extends BoxProps {
  children: React.ReactNode;
  disabled?: boolean;
  style?: React.CSSProperties;
}

export function Card(props: CardProps) {
  return (
    <Box
      m={3}
      p={3}
      style={{
        ...props.style,
        borderRadius: 6,
        backgroundColor: "#FFF",
        boxShadow: "0px 1px 4px #E1DEEE",
        position: "relative",
      }}
      {...props}
    >
      {props.children}
      {props.disabled ? (
        <Box
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            borderRadius: 6,
            backgroundColor: LIGHTEST_BACKGROUND,
            opacity: 0.6,
          }}
        />
      ) : null}
    </Box>
  );
}
